import {_getReportTemplates } from "@/services/reportTemplate/reportTemplate.js";
import {_getBusinessTypes } from "@/services/businessType/businessType.js";
import {_physicalProjectList, _projectName} from "@/services/screeningConfig/physicalProject.js";
import {_schoolsList, _gradesList, _gradesAll, _classesList, _classesAll, _nationsList, _applicableAgeList, _crowdList, _taskList, _studentsList} from "@/services/studentManage/studentManage";
import {_bloodTubeList, _lisProjectList} from "@/services/screeningConfig/lisProject.js";
import {_inspectOrganizeList} from "@/services/screeningConfig/inspectOrganize"
import {_getAcceptableAges} from "@/services/acceptableAge/acceptableAge";
import {_packagesName} from "@/services/screeningConfig/phlysicalPackage";
import {_fieldConfigList} from "@/services/screeningConfig/fieldConfig"

export const mixins = {
  data() {
    return {
      businessTypes :[],
      reportTemplates :[],
      physicalProjectList:[],
      projectNames:[],
      schoolsList:[],
      gradesList:[],
      gradesAll:[],
      classesList:[],
      classesAll:[],
      nationsList:[],
      applicableAgeList:[],
      crowdList:[],
      taskList:[],
      studentsList:[],
      lisProjectList:[],
      bloodTubeList:[],
      inspectOrganizeList:[],
      packagesNames:[],
      fieldConfigList:[],
      acceptableAges:[]
    };
  },
  computed: {},
  created() {
  },
  mounted() {},
  methods: {
    /**获取业务类型
     * */
    async applyBusinessTypes(){
      const res = await _getBusinessTypes()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            newArr.push({
              label: item.name,
              value: item.id
            })
          })
        }
        this.businessTypes = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**获取报告模版
     * */
    async applyReportTemplates(){
      const res = await _getReportTemplates()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            newArr.push({
              label: item.name,
              value: item.id
            })
          })
        }
        this.reportTemplates = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    async applyProjectName(){
      const res = await _projectName()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            newArr.push({
              label: item.name,
              pid: item.parentId,
              value: item.id,
            })
          })
        }
        this.projectNames = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    async applyPhysicalProjectList(){
      const res = await _physicalProjectList()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            newArr.push({
              label: item.name,
              pid: item.parentId,
              value: item.id,
              price: item.price,
              ... item
            })
          })
        }
        this.physicalProjectList = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**获取lis项目
     * */
    async applyLisProjectList(){
      const res = await _lisProjectList()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            let children=[];
            if (item.children){
              for (let i = 0; i < item.children.length; i++) {
                let  subItem = item.children[i]
                children.push({
                  label: subItem.name,
                  pid: subItem.pid,
                  value: subItem.id,
                  price: item.price,
                  projectType: item.projectType,
                  ... item
                })
              }
            }
            newArr.push({
              label: item.name,
              pid: item.parentId,
              value: item.id,
              children:children,
              ... item
            })
          })
        }
        this.lisProjectList = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**获取学校
     * */
    async applySchoolsList(){
      const res = await _schoolsList()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            const data = {
              ...item
            }
            data.label = item.name;
            data.value = item.id;
            newArr.push(data);
          })
        }
        this.schoolsList = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**根据学校获取年级
     * */
    async applyGradesList(data){
      const res = await _gradesList({schoolId : data})
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            const data = {
              ...item
            }
            data.label = item.name;
            data.value = item.id;
            newArr.push(data);
          })
        }
        this.gradesList = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**获取所有年级
     * */
    async applyGradesAll(){
      const res = await _gradesAll()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            const data = {
              ...item
            }
            data.label = item.name;
            data.value = item.id;
            newArr.push(data);
          })
        }
        this.gradesAll = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**根据年级获取班级
     * */
    async applyClassesList(data){
      const res = await _classesList({gradeId :data})
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            const data = {
              ...item
            }
            data.label = item.name;
            data.value = item.id;
            newArr.push(data);
          })
        }
        this.classesList = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**获取所有班级
     * */
    async applyClassesAll(data){
      const res = await _classesAll(data)
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            const data = {
              ...item
            }
            data.label = item.name;
            data.value = item.id;
            newArr.push(data);
          })
        }
        this.classesAll = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**获取所有民族
     * */
    async applyNationsList(){
      const res = await _nationsList()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            const data = {
              ...item
            }
            data.label = item.name;
            data.value = item.id;
            newArr.push(data);
          })
        }
        this.nationsList = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**获取所有适用年龄
     * */
    async applyApplicableAgeList(){
      const res = await _applicableAgeList()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            const data = {
              ...item
            }
            data.label = item.name;
            data.value = item.id;
            newArr.push(data);
          })
        }
        this.applicableAgeList = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**获取所有体检人群种类
     * */
    async applyCrowdList(){
      const res = await _crowdList()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            const data = {
              ...item
            }
            data.label = item.name;
            data.value = item.id;
            newArr.push(data);
          })
        }
        this.crowdList = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**获取所有体检任务
     * */
    async applyTaskList(){
      const res = await _taskList()
      try {
        let newArr = [];
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            const data = {...item}
            data.label = item.name;
            data.value = item.id;
            data.lisProjectCode = item.lisProjectCode;
            data.bloodTubeId = item.bloodTubeId;
            data.bloodTubeName = item.bloodTubeName;
            newArr.push(data);
          })
          this.taskList = newArr;
        }
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**获取所有学生
     * */
    async applyStudentsList(data){
      const res = await _studentsList(data)
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            const data = {
              ...item
            }
            data.label = item.name;
            data.value = item.id;
            newArr.push(data);
          })
        }
        this.studentsList = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**获取所有抽血试管类型
     * */
    async applyBloodTubeList(){
      const res = await _bloodTubeList()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            const data = {
              ...item
            }
            data.label = item.name;
            data.value = item.id;
            newArr.push(data);
          })
        }
        this.bloodTubeList = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**获取所有送检机构
     * */
    async applyInspectOrganizeList(){
      const res = await _inspectOrganizeList()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            const data = {
              ...item
            }
            data.label = item.name;
            data.value = item.id;
            newArr.push(data);
          })
        }
        this.inspectOrganizeList = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    async applyPackagesName(){
      const res = await _packagesName()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            newArr.push({
              id: item.id,
              name: item.name,
              label: item.name,
              pid: item.parentId,
              value: item.id,
            })
          })
        }
        this.packagesNames = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    async applyFieldConfigList(){
      const res = await _fieldConfigList()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            newArr.push({
              label: item.fieldName,
              pid: item.parentId,
              value: item.fieldId,
            })
          })
        }
        this.fieldConfigList = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
    /**获取所有送检机构
     * */
    async applyAcceptableAges(){
      const res = await _getAcceptableAges()
      try {
        let newArr = []
        if(res.data&&res.data.length>0){
          res.data.forEach(item=>{
            const data = {
              ...item
            }
            data.label = item.fieldName;
            data.value = item.id;
            newArr.push(data);
          })
        }
        this.acceptableAges = newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }
    },
  },
};
